import { useMemo } from "react";
import { parseAbsolute } from "@internationalized/date";

import Calendar from "../../Components/Calendar";

import { getNextThirdTuesday } from "../../Utils/helpers";

const nextThirdTuesday = getNextThirdTuesday();

export default function RentCalendar() {
  const calendarDefaultValue = useMemo(() => {
    const dayBeforeNextThirdTuesday = new Date(nextThirdTuesday);
    dayBeforeNextThirdTuesday.setDate(dayBeforeNextThirdTuesday.getDate() + 1);
    return parseAbsolute(dayBeforeNextThirdTuesday.toISOString());
  }, []);
  const calendarDefaultFocusedValue = useMemo(() => parseAbsolute(nextThirdTuesday.toISOString()), []);

  return (
    <div className="rent-calendar">
      <div className="section-header mb-0">
        <h3 className="section-title">Rent Calendar</h3>
      </div>
      <Calendar value={calendarDefaultValue} defaultFocusedValue={calendarDefaultFocusedValue} />
      <div className="calendar-legend mt-6 mb-3 mx-2">
        <div className="legend-item green">
          <span className="legend-badge"></span>Rent Match
        </div>
      </div>
    </div>
  );
}
